const state = {
  modal: {
    show: false,
  },
};

const mutations = {
  modal(_state, modal) {
    _state.modal = modal;
  },
};

const actions = {
  showModal(store) {
    store.commit('modal', {
      show: true,
    });
  },

  hideModal(store) {
    store.commit('modal', {
      show: false,
    });
  },
};

export default {
  namespaced: true,

  state,
  mutations,
  actions,
};
